"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadUserChallengeRanking = loadUserChallengeRanking;
exports.loadRanking = loadRanking;
exports.loadChallengeRanking = loadChallengeRanking;
exports.watchUserChallengeRanking = watchUserChallengeRanking;
exports.watchRanking = watchRanking;
exports.watchChallengeRanking = watchChallengeRanking;
exports["default"] = exports.rankingsSagas = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _utils = require("../../utils");

var _actions = _interopRequireDefault(require("./actions"));

var _selectors = require("./selectors");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _marked = _regenerator["default"].mark(loadUserChallengeRanking),
    _marked2 = _regenerator["default"].mark(loadRanking),
    _marked3 = _regenerator["default"].mark(loadChallengeRanking),
    _marked4 = _regenerator["default"].mark(watchUserChallengeRanking),
    _marked5 = _regenerator["default"].mark(watchRanking),
    _marked6 = _regenerator["default"].mark(watchChallengeRanking);

function loadUserChallengeRanking(api, action) {
  var _action$payload, challengeId, categoryParams, clientId, gender, userId, _action$payload$sort, sort, country, topParentChallenge, groupChallenge, _yield$api$getLeaderB, data;

  return _regenerator["default"].wrap(function loadUserChallengeRanking$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _action$payload = action.payload, challengeId = _action$payload.challengeId, categoryParams = _action$payload.categoryParams, clientId = _action$payload.clientId, gender = _action$payload.gender, userId = _action$payload.userId, _action$payload$sort = _action$payload.sort, sort = _action$payload$sort === void 0 ? 'duration' : _action$payload$sort, country = _action$payload.country, topParentChallenge = _action$payload.topParentChallenge, groupChallenge = _action$payload.groupChallenge;
          _context.next = 4;
          return api.getLeaderBoardByUserId({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId,
            gender: gender,
            categoryParams: categoryParams,
            sort: sort,
            country: country,
            topParentChallenge: topParentChallenge,
            groupChallenge: groupChallenge
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _yield$api$getLeaderB = _context.sent;
          data = _yield$api$getLeaderB.data;
          _context.next = 8;
          return (0, _effects.put)(_actions["default"].loadUserChallengeRankingSuccess(data));

        case 8:
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](0);
          _context.next = 14;
          return (0, _effects.put)(_actions["default"].loadUserChallengeRankingError(true));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 10]]);
}

function loadRanking(api, action) {
  var _action$payload2, challengeId, categoryParams, clientId, gender, rankingType, _action$payload2$sort, sort, skip, limit, search, _action$payload2$forc, forceReload, country, topParentChallenge, groupChallenge, groupChildrenId, group, subgroup, _yield$api$getLeaderB2, fullResponse, rankingData, prevData, nextData, newData;

  return _regenerator["default"].wrap(function loadRanking$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _action$payload2 = action.payload, challengeId = _action$payload2.challengeId, categoryParams = _action$payload2.categoryParams, clientId = _action$payload2.clientId, gender = _action$payload2.gender, rankingType = _action$payload2.rankingType, _action$payload2$sort = _action$payload2.sort, sort = _action$payload2$sort === void 0 ? 'duration' : _action$payload2$sort, skip = _action$payload2.skip, limit = _action$payload2.limit, search = _action$payload2.search, _action$payload2$forc = _action$payload2.forceReload, forceReload = _action$payload2$forc === void 0 ? false : _action$payload2$forc, country = _action$payload2.country, topParentChallenge = _action$payload2.topParentChallenge, groupChallenge = _action$payload2.groupChallenge, groupChildrenId = _action$payload2.groupChildrenId, group = _action$payload2.group, subgroup = _action$payload2.subgroup;
          _context2.next = 4;
          return api.getLeaderBoard({
            challengeId: challengeId,
            clientId: clientId,
            rankingType: rankingType,
            gender: gender,
            categoryParams: categoryParams,
            sort: sort,
            skip: skip,
            limit: limit,
            search: search,
            forceReload: forceReload,
            country: country,
            topParentChallenge: topParentChallenge,
            groupChallenge: groupChallenge,
            groupChildrenId: groupChildrenId,
            subgroup: subgroup,
            group: group
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _yield$api$getLeaderB2 = _context2.sent;
          fullResponse = _yield$api$getLeaderB2.data;
          _context2.next = 8;
          return (0, _effects.select)(_selectors.rankingDataSelector);

        case 8:
          rankingData = _context2.sent;
          prevData = rankingData || [];
          nextData = fullResponse.data || [];
          newData = forceReload ? nextData : [].concat((0, _toConsumableArray2["default"])(prevData), (0, _toConsumableArray2["default"])(nextData));
          _context2.next = 14;
          return (0, _effects.put)(_actions["default"].loadRankingSuccess(_objectSpread({}, fullResponse, {
            data: newData
          })));

        case 14:
          _context2.next = 20;
          break;

        case 16:
          _context2.prev = 16;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 20;
          return (0, _effects.put)(_actions["default"].loadRankingError(true));

        case 20:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 16]]);
}

function loadChallengeRanking(api, action) {
  var _action$payload3, challengeId, categoryParams, clientId, gender, rankingType, _action$payload3$sort, sort, skip, limit, search, _action$payload3$forc, forceReload, country, topParentChallenge, groupChallenge, _yield$api$getLeaderB3, fullResponse, challengeRankingData, prevData, nextData, newData;

  return _regenerator["default"].wrap(function loadChallengeRanking$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _action$payload3 = action.payload, challengeId = _action$payload3.challengeId, categoryParams = _action$payload3.categoryParams, clientId = _action$payload3.clientId, gender = _action$payload3.gender, rankingType = _action$payload3.rankingType, _action$payload3$sort = _action$payload3.sort, sort = _action$payload3$sort === void 0 ? 'duration' : _action$payload3$sort, skip = _action$payload3.skip, limit = _action$payload3.limit, search = _action$payload3.search, _action$payload3$forc = _action$payload3.forceReload, forceReload = _action$payload3$forc === void 0 ? false : _action$payload3$forc, country = _action$payload3.country, topParentChallenge = _action$payload3.topParentChallenge, groupChallenge = _action$payload3.groupChallenge;
          _context3.next = 4;
          return api.getLeaderBoard({
            challengeId: challengeId,
            clientId: clientId,
            rankingType: rankingType,
            gender: gender,
            categoryParams: categoryParams,
            sort: sort,
            skip: skip,
            limit: limit,
            search: search,
            forceReload: forceReload,
            country: country,
            topParentChallenge: topParentChallenge,
            groupChallenge: groupChallenge
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _yield$api$getLeaderB3 = _context3.sent;
          fullResponse = _yield$api$getLeaderB3.data;
          _context3.next = 8;
          return (0, _effects.select)(_selectors.challengeRankingDataSelector);

        case 8:
          challengeRankingData = _context3.sent;
          prevData = challengeRankingData || [];
          nextData = fullResponse.data || [];
          newData = forceReload ? nextData : [].concat((0, _toConsumableArray2["default"])(prevData), (0, _toConsumableArray2["default"])(nextData));
          _context3.next = 14;
          return (0, _effects.put)(_actions["default"].loadChallengeRankingSuccess(_objectSpread({}, fullResponse, {
            data: newData
          })));

        case 14:
          _context3.next = 20;
          break;

        case 16:
          _context3.prev = 16;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 20;
          return (0, _effects.put)(_actions["default"].loadChallengeRankingError(true));

        case 20:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 16]]);
}

function watchUserChallengeRanking(api) {
  return _regenerator["default"].wrap(function watchUserChallengeRanking$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserChallengeRanking), loadUserChallengeRanking, api);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function watchRanking(api) {
  return _regenerator["default"].wrap(function watchRanking$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadRanking), loadRanking, api);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function watchChallengeRanking(api) {
  return _regenerator["default"].wrap(function watchChallengeRanking$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadChallengeRanking), loadChallengeRanking, api);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

var rankingsSagas = function rankingsSagas(api) {
  return [(0, _effects.fork)(watchUserChallengeRanking, api), (0, _effects.fork)(watchRanking, api), (0, _effects.fork)(watchChallengeRanking, api)];
};

exports.rankingsSagas = rankingsSagas;
var _default = rankingsSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map